// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6.67 14.67V5.25C6.67 4.56 6.11 4 5.42 4H3.33C2.23 4 1.33 4.9 1.33 6V12.67C1.33 13.77 2.23 14.67 3.33 14.67H10C11.1 14.67 12 13.77 12 12.67V10.58C12 9.89 11.44 9.33 10.75 9.33H1.33',
  'M10.83 1.33H13.17C14 1.33 14.67 2 14.67 2.83V5.17C14.67 6 14 6.67 13.17 6.67H10.83C10 6.67 9.33 6 9.33 5.17V2.83C9.33 2 10 1.33 10.83 1.33Z',
];
